import { formatDate } from "../FormatDate/FormatDate";

export const getDateRangeTitle = (data, dateField, prefix = "Liste des données du") => {
  if (!data?.length) return `${prefix} -`;
  const sorted = [...data].sort((a, b) => new Date(a[dateField]) - new Date(b[dateField]));
  const min = formatDate(sorted[0][dateField], true);
  const max = formatDate(sorted[sorted.length - 1][dateField], true);
  return `${prefix} ${min} au ${max}`;
};
